import { render, staticRenderFns } from "./selectMaterial.vue?vue&type=template&id=4294588b&scoped=true"
import script from "./selectMaterial.vue?vue&type=script&lang=js"
export * from "./selectMaterial.vue?vue&type=script&lang=js"
import style0 from "./selectMaterial.vue?vue&type=style&index=0&id=4294588b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4294588b",
  null
  
)

export default component.exports